<div mat-dialog-content>
    <div class="mainDiv">

        <form>

            <span> Min &nbsp;&nbsp;&nbsp;<input type="number" [(ngModel)]="min" [ngModelOptions]="{standalone: true}" style="margin-top: 10px;border-radius: 7px;"  ></span><br>

            <span> Max &nbsp;<input type="number" [(ngModel)]="max" [ngModelOptions]="{standalone: true}" style="margin-top: 10px;border-radius: 7px;" ></span><br>
         
            <div style="float: right; margin-top: 10px;margin-bottom:10px">
                <button type="submit" mat-button style="margin-right: 5px;" class="btn btncls"
                  (click)="onSubmit()" >Ok</button>
                <button mat-button class="btn btncls" (click)="onNoClick()">Cancel</button>
            </div>
        </form>
    </div>
</div>


<style>
    .btncls {
        width: 80px;
        color: white;
        background-color: #234a90;
    }

    .mainDiv {
        padding: 20px 20px 50px 20px;
    }

    ::ng-deep .mat-dialog-container {
        overflow: inherit;
    }

    ::ng-deep .cdk-overlay-dark-backdrop {
        background: rgb(0 0 0 / 0%);
    }
</style>